import { END_POINTS } from '../helpers';
import { FeatureData, CommonBody } from '../types/General';
import emptySplitApi from '../utils/rtk';

type CommonResponse = {
  statusCode: number;
  message: string;
};

type GetFeaturesResponse = {
  count: number;
  data: FeatureData[];
};

export const featureApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getFeatures: builder.query<
      CommonResponse & { data: GetFeaturesResponse },
      {
        page: number;
        limit: number;
        search: string;
        vehicleId?: string;
      }
    >({
      query: ({ page, limit, search, vehicleId }) => ({
        url: `${END_POINTS.getFeatures}?page=${page}&limit=${limit}${
          search?.length ? `&search=${search}` : ''
        }${vehicleId ? `&vehicleId=${vehicleId}` : ''}`,
        method: 'GET',
      }),
    }),

    deleteFeature: builder.query<CommonResponse, { id: string }>({
      query: ({ id }) => ({
        url: `${END_POINTS.deleteFeature}/${id}`,
        method: 'DELETE',
      }),
    }),
    getFeatureById: builder.query<CommonResponse & { data: FeatureData }, { id: string }>({
      query: ({ id }) => ({
        url: `${END_POINTS.getFeatureById}/${id}`,
        method: 'GET',
      }),
    }),

    addFeature: builder.mutation<CommonResponse & { data: FeatureData }, { body: CommonBody }>({
      query: ({ body }) => ({
        url: `${END_POINTS.addFeature}`,
        method: 'POST',
        body,
      }),
    }),
    updateFeature: builder.mutation<
      CommonResponse & { data: FeatureData },
      { body: CommonBody; id: string | undefined }
    >({
      query: ({ body, id }) => ({
        url: `${END_POINTS.updateFeature}/${id}`,
        method: 'PUT',
        body,
      }),
    }),
  }),
});

export const {
  useAddFeatureMutation,
  useUpdateFeatureMutation,
  useLazyGetFeaturesQuery,
  useLazyDeleteFeatureQuery,
  useLazyGetFeatureByIdQuery,
} = featureApi;
